import { Channel } from 'types'

const isDirectQuote = (channel?: Channel): boolean => {
  return channel === 'WEB'
}

export const shouldShowDirectFeature = (featureFlag: boolean, channel?: Channel): boolean => {
  return isDirectQuote(channel) && featureFlag
}

export const shouldShowPcwFeature = (featureFlag: boolean, channel?: Channel): boolean => {
  return !isDirectQuote(channel) && featureFlag
}
